<template>
  <div :class="box_class">
    <div class="box-header with-border" v-if="title || $slots.header || $slots.tools">
      <h3 class="box-title" v-if="title" v-html="title"></h3>
      <h3 class="box-tab" :class="item.active?'active':''" v-for="(item ,index) in tabs" :key="index" @click="onTabClick(item)" v-html="item.title"></h3>
      <slot name="header" />
      <div v-if="$slots.tools || showClose" class="box-tools">
        <slot name="tools" />
        <el-button v-if="showClose" type="text" @click="onClose" class="btn btn-box-tool">
          <i class="icon icon-close"></i>
        </el-button>
      </div>
    </div>
    <div class="box-body" :style="bbs" :class="noPadding ? 'no-padding' : ''">
      <slot />
    </div>
    <div v-if="$slots.footer" class="box-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      required: false,
      default: 'default'
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    showClose: {
      type: Boolean,
      required: false,
      default: false
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: false
    },
    fixtop: Number,
    bodyStyle: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      default: () => ([])
    }
  },
  mounted () {

  },
  computed: {
    box_class () {
      let re = 'box'
      if (this.theme) {
        re += ` box-${this.theme}`
      }
      if (this.tabs && this.tabs.length > 0) {
        re += ' box-tabs'
      }
      return re
    },
    bbs () {
      let re = this.bodyStyle || ''
      if (this.fixtop && this.fixtop > 0) {
        let boxHeight = this.$store.state.screenHeight - this.fixtop
        re += `;height: ${boxHeight}px; overflow: auto;`
      }
      return re
    }
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    },
    onTabClick (item) {
      this.$emit('onTabClick', item)
    }
  }
}
</script>
